<template>
  <div v-if="inPreview">
    <div v-if="generatingPreview" class="relative">
      <b-skeleton
        animation="fade"
        width="100%"
        height="60vh"
      />
      <div class="absolute top-0 left-0 w-100 h-100 d-flex justify-center items-center gap-4">
        <b-spinner />
        <span>Generando previsualización</span>
      </div>
    </div>
    <b-overlay :show="saving">
      <iframe
        v-if="!generatingPreview && pdfUrl !== '' && pdfUrl != null"
        class="w-100"
        :src="pdfUrl"
        style="height: 70vh;"
        name="pdfPreviewIframe"
        title="pdfPreviewIframe"
      />
      <template #overlay>
        <div class="d-flex justify-content-center align-items-center">
          <b-spinner
            class="mr-2"
          />
          <small>Creando documento...</small>
        </div>
      </template>
      <div class="absolute top-0 left-0 z-10" v-if="!generatingPreview">
        <vx-tooltip text="Recargar previsualización" placement="top">
          <vs-button
            class="ml-4 mt-4"
            size="small"
            color="primary"
            icon="refresh"
            @click="handlePreview"
          />
        </vx-tooltip>
      </div>
    </b-overlay>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="setInPreview(false)"
        color="primary"
        :disabled="generatingPreview || saving"
      >
        Volver
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="$emit('save')"
        color="success"
        :disabled="generatingPreview || saving"
      >
        Crear
      </vs-button>
    </div>
  </div>
</template>

<script>
import { ioCreateCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { showToast } from '@/febos/global/customDocuments/utils/showToast';

export default {
  name: 'pdf-preview',
  data() {
    return {
      formData: {},
      pdfUrl: '',
      inPreview: false,
      generatingPreview: false,
    };
  },
  methods: {
    setInPreview(val) {
      this.inPreview = val;
      this.$emit('in-preview', val);
    },
    handlePreview() {
      const hasSavePreview = this.$listeners && this.$listeners['save-preview'];

      if (hasSavePreview) {
        this.$emit('save-preview');
        return;
      }
      this.preview();
    },
    setFormData(formData) {
      this.formData = formData;
    },
    async preview(formData) {
      if (!this.formData) {
        return;
      }
      this.pdfUrl = '';
      this.generatingPreview = true;
      this.setInPreview(true);

      const { closeToast } = showToast(this, 'Generando previsualización', 'En camino...', {
        noAutoHide: true,
        noCloseButton: true,
      });

      try {
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si'
          },
          formData: {
            ...this.formData,
            borrador: true
          },
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);
        closeToast();

        if (!pdf || pdf === '') {
          showToast(this, 'No se pudo generar la previsualización', 'Ups!', {
            variant: 'warning',
          });

          this.setInPreview(false);
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } catch (e) {
        this.setInPreview(false);
      } finally {
        closeToast();
        this.generatingPreview = false;
      }
    },
  },
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
